import { useEffect, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import "../../../styles/website/Layout.css";

function ScrollToTopIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 15L12 9L18 15"
        stroke="currentColor"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY > 420);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  function handleClick() {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
  }

  return (
    <button
      type="button"
      className={`scroll-top-btn${visible ? " is-visible" : ""}`}
      onClick={handleClick}
      aria-label="بازگشت به بالای صفحه"
    >
      <ScrollToTopIcon />
    </button>
  );
}

export default function Layout({ children }) {
  return (
    <div className="dokana" dir="rtl">
      <div className="bg"></div>
      <Header />
      {children}
      <Footer />
      <ScrollToTop />
    </div>
  );
}
